var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "shortsPlatform_Function"
  }, [_c("section", {
    staticClass: "shortsPlatform_Function_bg"
  }, [_c("Title", {
    staticClass: "bg-title",
    attrs: {
      title: "产品功能"
    }
  }), _c("div", {
    staticClass: "bg-main"
  })], 1), _c("FuncList", {
    attrs: {
      imageUrl: _vm.imageFunc,
      rowCol: 3,
      itemList: _vm.itemList
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };